import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getMsgConfigsService = (modelId) => {
    return getData(`Messages/GetMessagesByModelId/${modelId}`);
} 

export const getMsgConfigsDetailsService = (msgId) => {
    return getData(`Messages/GetMessage/${msgId}`);
}

export const createConfigureMessage = (payload) => {
    return postData('Messages/CreateMessage', payload);
}

export const deleteMsgConfigService = (msgId) => {
    return deleteData(`Messages/DeleteMessage/${msgId}`);
}

export const updateConfigureMessage = (payload) => {
    return putData('Messages/UpdateMessage', payload);
}